/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Activity_AskingInputs */

const en_us2_coach_extra_activity_asking = /** @type {(inputs: Coach_Extra_Activity_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing a question…`)
};

const pt_br2_coach_extra_activity_asking = /** @type {(inputs: Coach_Extra_Activity_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando uma pergunta…`)
};

const es_419_coach_extra_activity_asking = /** @type {(inputs: Coach_Extra_Activity_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando una pregunta…`)
};

const pt_pt2_coach_extra_activity_asking = /** @type {(inputs: Coach_Extra_Activity_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A preparar uma pergunta…`)
};

const fr_fr2_coach_extra_activity_asking = /** @type {(inputs: Coach_Extra_Activity_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation d'une question…`)
};

const de_de2_coach_extra_activity_asking = /** @type {(inputs: Coach_Extra_Activity_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereite eine Frage vor…`)
};

const it_it2_coach_extra_activity_asking = /** @type {(inputs: Coach_Extra_Activity_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparo una domanda…`)
};

/**
* | output |
* | --- |
* | "Preparing a question…" |
*
* @param {Coach_Extra_Activity_AskingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_activity_asking = /** @type {((inputs?: Coach_Extra_Activity_AskingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Activity_AskingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_activity_asking(inputs)
	if (locale === "es-419") return es_419_coach_extra_activity_asking(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_activity_asking(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_activity_asking(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_activity_asking(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_activity_asking(inputs)
	return en_us2_coach_extra_activity_asking(inputs)
});
export { coach_extra_activity_asking as "coach-extra.activity_asking" }